/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type LocalReplyListContainer_story = {
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_story">;
    readonly " $refType": "LocalReplyListContainer_story";
};
export type LocalReplyListContainer_story$data = LocalReplyListContainer_story;
export type LocalReplyListContainer_story$key = {
    readonly " $data"?: LocalReplyListContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"LocalReplyListContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "LocalReplyListContainer_story",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_story"
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = 'bc11a20e1701ba05a43b81e7b941d756';
export default node;
